import { SurveyQuestionnaireDeerPage } from 'Deer/components/Engagement/SurveyFormFilling/SurveyQuestionnaireDeerPage';

export const SurveyPreview = () => <SurveyQuestionnaireDeerPage isPreview />;
